import React from "react";
import LandingBackground from "../images/LandingBackground";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import {
  Box,
  Button,
  Container,
  Grid,
  Toolbar,
  withStyles,
  Typography,
} from "@material-ui/core";

const styles = theme => ({
  landingBackground: {
    position: "relative",
  },
  sectionOnTop: {
    color: "white",
    position: "relative",
    "&::before": {
      content: '" "',
      position: "absolute",
      top: "0",
      left: "0",
      height: "100%",
      width: "100%",
      background: "linear-gradient(135deg, #3180de, #1e5abb, #69b3e6)",
      opacity: 0.75,
    },
  },
  content: {
    position: 'relative',
    padding: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4),
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  subtitle: {
    color: theme.palette.common.white,
    fontWeight: "500",
  },
  title: {
    fontWeight: "700",
    color: theme.palette.secondary.white,
    marginBottom: theme.spacing(4),
    fontSize: '3em',
    [theme.breakpoints.up("sm")]: {
      fontSize: '5em',
    },
  },
  loginButton: {
    color: "white",
    borderColor: "white",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: "100%",
      transform: "scaleX(0)",
      height: "2px",
      bottom: "0",
      left: "0",
      backgroundColor: "yellow",
      transition: "transform 0.25s ease-out",
    },
    "&:hover": {
      "&:after": {
        transform: "scaleX(1)",
      },
    },
  },
});


const HeroImage = ({ classes }) => (
  <LandingBackground>
    <Box className={classes.sectionOnTop}>
      <Container component="header">
        <Toolbar className={classes.toolbar}>
          <StaticImage
            src="../../images/logo-fiberID.png"
            alt="FiberID"
            width={150}
            placeholder="none"
          />
          <Link to="/login">
            <Button className={classes.loginButton}>Zaloguj się</Button>
          </Link>
        </Toolbar>

        <Grid
          container
          className={classes.content}
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item md={8}>
            <Box p={3}>
              <Typography variant="h2" className={classes.title} paragraph>
                Sprawdź, czy użytkownik jest tym za kogo się podaje
              </Typography>
              <Typography variant="h4" className={classes.subtitle}>
                FiberID API pozwala Twojej aplikacji zweryfikować tożsamość
                osób, które obsługujesz - bez konieczności osobistego kontaktu,
                automatycznie i bezpiecznie
              </Typography>
            </Box>
          </Grid>
          <Grid item md={4}>
            <StaticImage
              src="../../images/fiberID-phone.png"
              alt="FiberID application"
              minwidth={400}
              placeholder="none"
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  </LandingBackground>
);

export default withStyles(styles)(HeroImage);
